import React from 'react';
import { X, CheckCheck, AlertCircle, Info } from 'lucide-react';
import './NotificationDropdown.css';

const NotificationDropdown = ({
  notifications,
  onClose,
  onMarkAsRead,
  onMarkAllAsRead,
  onClear,
}) => {
  const getSeverityIcon = (severity) => {
    switch (severity?.toUpperCase()) {
      case 'HIGH':
        return <AlertCircle size={16} className="severity-icon severity-high" />;
      case 'MEDIUM':
        return <AlertCircle size={16} className="severity-icon severity-medium" />;
      case 'LOW':
      default:
        return <Info size={16} className="severity-icon severity-low" />;
    }
  };

  const getSeverityClass = (severity) => {
    return `notification-item severity-${severity?.toLowerCase() || 'low'}`;
  };

  const formatTimestamp = (createdAt) => {
    const date = new Date(createdAt);
    const now = new Date();
    const diffInSeconds = Math.floor((now - date) / 1000);

    if (diffInSeconds < 60) {
      return 'just now';
    } else if (diffInSeconds < 3600) {
      const minutes = Math.floor(diffInSeconds / 60);
      return `${minutes}m ago`;
    } else if (diffInSeconds < 86400) {
      const hours = Math.floor(diffInSeconds / 3600);
      return `${hours}h ago`;
    } else {
      const days = Math.floor(diffInSeconds / 86400);
      return `${days}d ago`;
    }
  };

  const handleNotificationClick = (notificationId) => {
    onMarkAsRead(notificationId);
  };

  const handleClearClick = (e, notificationId) => {
    e.stopPropagation();
    onClear(notificationId);
  };

  const unreadCount = notifications.filter((n) => !n.isRead).length;

  return (
    <div className="notification-dropdown">
      <div className="notification-dropdown-header">
        <h3>Notifications</h3>
        <button
          className="dropdown-close-btn"
          onClick={onClose}
          aria-label="Close notifications"
        >
          <X size={18} />
        </button>
      </div>

      <div className="notification-dropdown-actions">
        {unreadCount > 0 && (
          <button className="action-btn" onClick={onMarkAllAsRead}>
            <CheckCheck size={14} /> Mark all as read
          </button>
        )}
      </div>

      <div className="notification-dropdown-list">
        {notifications.length === 0 ? (
          <div className="notification-empty-state">
            <p>No notifications</p>
          </div>
        ) : (
          notifications.map((notification) => (
            <div
              key={notification.id}
              className={`${getSeverityClass(notification.severity)} ${
                !notification.isRead ? 'unread' : ''
              }`}
              onClick={() => handleNotificationClick(notification.id)}
            >
              <div className="notification-item-content">
                <div className="notification-item-header">
                  <div className="notification-item-title-section">
                    {getSeverityIcon(notification.severity)}
                    <strong className="notification-item-title">
                      {notification.title}
                    </strong>
                  </div>
                  <button
                    className="notification-item-close"
                    onClick={(e) => handleClearClick(e, notification.id)}
                    aria-label="Remove notification"
                  >
                    <X size={14} />
                  </button>
                </div>
                <p className="notification-item-message">{notification.message}</p>
                <div className="notification-item-footer">
                  <span className="notification-item-time">
                    {formatTimestamp(notification.createdAt)}
                  </span>
                  <span className="notification-item-severity">
                    {notification.severity}
                  </span>
                </div>
              </div>
              {!notification.isRead && <div className="unread-indicator"></div>}
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default NotificationDropdown;
